import * as React from 'react';

import { BaseExercisePage } from '../baseExercisePage';
import { Tracking } from './tracking';
import * as Edge from '../../../core';

import TrackingResults from './results';
import TrackingConfigForm from './configForm';

export default class TrackingPage extends BaseExercisePage<
	Edge.Models.TrackingExerciseConfiguration,
	Edge.Models.TrackingExerciseResult
> {
	protected renderConfiguration(): JSX.Element {
		const { lockConfiguration, operationName, mode } = this.props;
		const { configuration } = this.state;

		return (
			<TrackingConfigForm
				mode={mode}
				operationName={operationName}
				onSubmit={this.startExercise}
				initialConfiguration={configuration}
				lockConfiguration={lockConfiguration}
			/>
		);
	}
	protected renderExercise(): JSX.Element {
		const { currentProfile, mode } = this.props;
		const { configuration, fullScreen } = this.state;

		return (
			<Tracking
				mode={mode}
				debugMode={this.props.debugMode}
				renderScale={currentProfile.renderScale}
				touchControls={currentProfile.touchControls}
				fullScreen={fullScreen!}
				completeExercise={this.finishExercise}
				abortingExercise={this.abortingExercise}
				configuration={configuration}
			/>
		);
	}
	protected renderResults(): JSX.Element {
		const { hideExerciseResults } = this.props;

		return (
			<TrackingResults
				results={this.state.result!}
				complete={this.complete}
				retry={this.retryExercise}
				completeText={this.props.completeText}
				hideExerciseResults={hideExerciseResults}
			/>
		);
	}
}
